// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, h1, p, button {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, sans-serif; /* Ensure same font across all elements */
}

body {
  display: flex;
  justify-content: center;
  height: 100vh;
  margin: 0;
  background-color: #f4f4f4;
}

.container {
  text-align: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 3vw;
  color: #333;
  align-items: center;
  text-align: center;
  padding-top: 30vh;
}

:root {
  --primary-color: green;
}

.dropdown-container {
  text-align: center;
}

.custom-dropdown {
  position: relative;
  display: inline-block;
  width: 21vw;
  border-bottom: 2px solid var(--primary-color);
  padding: 8px 10px;
  font-size: 1vw;
  cursor: pointer;
  font-weight: bold;
}

.custom-dropdown-selected {
  display: flex;
  align-items: center;
  color: var(--primary-color);;
  position: relative; /* To position the selected text correctly */
  top: 0.5vw; /* Fine-tune this value to position the text over the underline */
}

.arrow-down {
  font-size: 3vw;
  color: var(--primary-color);;
  display: inline-block;
  transition: transform 0.2s ease;
}

.arrow-down.rotate-right {
  transform: rotate(-90deg); /* Default: arrow pointing to the right */
}

.arrow-down.rotate-down {
  transform: rotate(0deg); /* Dropdown open: arrow pointing down */
}

.custom-dropdown-selected-text {
  font-size: 2.4vw;
  position: absolute; 
  top: 0.5vw;
  transform: translateY(0);
  opacity: 1;
  left: 2vw;
  right: 0;
  text-align: center;
  transition: none;
}

@keyframes fade-slide {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-dropdown .custom-dropdown-selected-text.animate {
  animation: fade-slide 0.3s ease;
}

.custom-dropdown-options {
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #ddd;
  border-top: none;
  z-index: 10;
  font-size: 1rem;

  max-height: 0; /* Collapsed state */
  opacity: 0; /* Invisible */
  overflow: hidden; /* Hide content outside bounds */
  transform: translateY(-10px); /* Start slightly above the green underline */
  transition: transform 0.3s ease, opacity 0.3s ease, max-height 0.3s ease;
}

.custom-dropdown-options.open {
  max-height: 500px; /* Expanded state */
  opacity: 1; /* Fully visible */
  transform: translateY(0); /* Slide down into place */
}

.custom-dropdown-option {
  padding: 10px;
  cursor: pointer;
  color: #333;
}

.custom-dropdown-option:hover {
  background-color: #f0f0f0;
  color: var(--primary-color);;
}

.question-mark {
  font-size: 3.5vw;
  color: #333;
  font-family: Arial, sans-serif; 
  font-weight: bold; 
  line-height: 1;
  vertical-align: middle; 
  margin-left: 10px;
}

.data-container {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.fade-out {
  opacity: 0;
}

.fade-in {
  opacity: 1;
}

.chart-container {
  width: 40vw;  
  height: 20vw;  
  margin: 0 auto;  
  padding-top: 2vw;
  padding-bottom: 10vw;
  justify-items: center;
}

.chart-container h1 {
  font-size: 2.4vw;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  color: #333;
  padding: 20px 0;
  text-align: center;
}

.chart-container p {
  text-align: center;
  color:#595959;
  font-size: 0.7vw;
}

.chart-container.doughnut {
  height: 25vw;
  padding-bottom: 8vw;
}

#doughnut {
  position: relative;
}

.chart-container.country-chart {
  width: 50vw;
  height: 30vw;
  padding-bottom: 5vw;
}

#countryChart {
  width: 100%;
  height: 100%; 
}

.stat {
  padding-top: 5vw;
  font-size: 3vw;
  text-align: center;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  color: #333;
}

.stat-text, .stat-percent, .stat-timeframe {
  display: inline;
}

.stat-percent.positive{
  color: green;
}

.stat-percent.negative{
  color: firebrick;
}

.wip {
  padding-top: 5vw;
}

.wip h1 {
  padding-top: 2vw;
}

.wip p {
  padding-top: 2vw;
  text-align: center;

}

.section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.section.b {
  background-color: #eaeaea;
  width: 100vw;
}

.chart-container.table {
  height: 13vw;
}

#office-table {
  border-collapse: collapse;
  margin: 20px 0;
  width: 50vw;
}

#office-table th, #office-table td {
  padding: 12px 15px;
  border: 2px solid #ddd;
  text-align: center;
  font-family: 'Arial', sans-serif;
}

#office-table th {
  background-color: #eaeaea;
  font-weight: bold;
  font-size: 2.4vw;
}

#office-table td {
  font-size: 2.4vw;
}

.row-0 {
  color: green;
}

.row-2 {
  color: firebrick;
}

.methodology-toggle {
  cursor: pointer;
}

.methodology-toggle:hover {
  text-decoration: underline;
}

.methodology-toggle h1 {
  padding-top: 0vw;
  padding: 2vw;
}

.methodology-toggle .arrow-down {
  color: #333;
}

.methodology-panel {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  width: 45vw;
  margin: 0 auto;
  display: block;
  font-size: 15px;
  justify-self: center;
  text-align: center;
  font-style: italic;
}

.methodology-panel.open {
  display: block;
  width: 45vw;
  max-height: 500px;
  transition: max-height 0.3s ease-in;
  padding-bottom: 2vw;
}

.methodology-panel.closed {
  display: none;
  max-height: 0;
}

.methodology-panel ul {
  list-style-position: inside; 
  padding: 0; 
  margin: 0 auto; 
  display: inline-block;
  text-align: left;
}

.copyright {
  font-size: 15px;
  text-align: center;
  padding: 15px;
  color: #b2b2b2;
}


@media (max-width: 767px) {
  h1 {
      font-size: 8vw;
      padding-top: 40vh;
  }

  .question-mark {
      position: absolute;
      font-size: 10vw;
      padding-top: 3vw;
  }

  .custom-dropdown {
    width: 55vw;
    padding-top: 3vw;
  }

  .custom-dropdown-selected-text {
    font-size: 8vw;
    top: 0vw;
    left: 4vw;
  }

  .custom-dropdown-options {
    font-size: 5vw;
  }

  .arrow-down {
    font-size: 8vw;
  }

  .chart-container {
    padding-top: 5vw;
    width: 80vw;  
    margin: 0 auto;  
    padding-bottom: 20vw;
    min-height: 30vh;
  }

  .chart-container#postings {
    padding-bottom: 29vw;
  }

  .chart-container h1 {
    font-size: 5vw;
  }


  .stat {
    padding-top: 10vw;
    font-size: 8vw;
    flex-direction: column;
    gap: 0;
  }

  .stat-text, .stat-percent, .stat-timeframe {
    display: block;
    text-align: center;
  }

  .chart-container.doughnut{
    position: relative;
    height: 80vw;
    width: 100%;
    padding-bottom: 25vw;
  }
  
  #doughnut {
    top: 0vw;
    left: 0vw;
    width: 100%;
    height: 30vw;
    left: 10vw;
  }

  .chart-container.country-chart {
    position: relative;
    padding-bottom: 5vw;
    right: 3vw;
    width: 100vw;
    height: 30vh;
  }

  .chart-container.table {
    padding-bottom: 0vw;
    width: 100vw;
    justify-content: center;
  }

  #office-table {
    position: relative;
    width: 90vw;
    left: 5vw;
  }
  
  #office-table th {
    font-size: 4vw;
  }
  
  #office-table td {
    font-size: 4vw;
  }

  .methodology-panel.open {
    width: 95vw;
    font-size: 12px;
  }
  
  .copyright {
    font-size: 15px;
    text-align: center;
    padding: 15px;
    color: #b2b2b2;
  }

  .chart-container p {
    font-size: 3vw;
  }

}`, "",{"version":3,"sources":["webpack://./src/assets/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,8BAA8B,EAAE,yCAAyC;AAC3E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,6CAA6C;EAC7C,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB,EAAE,4CAA4C;EAChE,UAAU,EAAE,iEAAiE;AAC/E;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;;EAEf,aAAa,EAAE,oBAAoB;EACnC,UAAU,EAAE,cAAc;EAC1B,gBAAgB,EAAE,gCAAgC;EAClD,4BAA4B,EAAE,6CAA6C;EAC3E,wEAAwE;AAC1E;;AAEA;EACE,iBAAiB,EAAE,mBAAmB;EACtC,UAAU,EAAE,kBAAkB;EAC9B,wBAAwB,EAAE,0BAA0B;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;;AAGA;EACE;MACI,cAAc;MACd,iBAAiB;EACrB;;EAEA;MACI,kBAAkB;MAClB,eAAe;MACf,gBAAgB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;;EAGA;IACE,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;AAEF","sourcesContent":["body, h1, p, button {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: Arial, sans-serif; /* Ensure same font across all elements */\n}\n\nbody {\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n  margin: 0;\n  background-color: #f4f4f4;\n}\n\n.container {\n  text-align: center;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\nh1 {\n  font-size: 3vw;\n  color: #333;\n  align-items: center;\n  text-align: center;\n  padding-top: 30vh;\n}\n\n:root {\n  --primary-color: green;\n}\n\n.dropdown-container {\n  text-align: center;\n}\n\n.custom-dropdown {\n  position: relative;\n  display: inline-block;\n  width: 21vw;\n  border-bottom: 2px solid var(--primary-color);\n  padding: 8px 10px;\n  font-size: 1vw;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.custom-dropdown-selected {\n  display: flex;\n  align-items: center;\n  color: var(--primary-color);;\n  position: relative; /* To position the selected text correctly */\n  top: 0.5vw; /* Fine-tune this value to position the text over the underline */\n}\n\n.arrow-down {\n  font-size: 3vw;\n  color: var(--primary-color);;\n  display: inline-block;\n  transition: transform 0.2s ease;\n}\n\n.arrow-down.rotate-right {\n  transform: rotate(-90deg); /* Default: arrow pointing to the right */\n}\n\n.arrow-down.rotate-down {\n  transform: rotate(0deg); /* Dropdown open: arrow pointing down */\n}\n\n.custom-dropdown-selected-text {\n  font-size: 2.4vw;\n  position: absolute; \n  top: 0.5vw;\n  transform: translateY(0);\n  opacity: 1;\n  left: 2vw;\n  right: 0;\n  text-align: center;\n  transition: none;\n}\n\n@keyframes fade-slide {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.custom-dropdown .custom-dropdown-selected-text.animate {\n  animation: fade-slide 0.3s ease;\n}\n\n.custom-dropdown-options {\n  position: absolute;\n  top: 110%;\n  left: 0;\n  right: 0;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-top: none;\n  z-index: 10;\n  font-size: 1rem;\n\n  max-height: 0; /* Collapsed state */\n  opacity: 0; /* Invisible */\n  overflow: hidden; /* Hide content outside bounds */\n  transform: translateY(-10px); /* Start slightly above the green underline */\n  transition: transform 0.3s ease, opacity 0.3s ease, max-height 0.3s ease;\n}\n\n.custom-dropdown-options.open {\n  max-height: 500px; /* Expanded state */\n  opacity: 1; /* Fully visible */\n  transform: translateY(0); /* Slide down into place */\n}\n\n.custom-dropdown-option {\n  padding: 10px;\n  cursor: pointer;\n  color: #333;\n}\n\n.custom-dropdown-option:hover {\n  background-color: #f0f0f0;\n  color: var(--primary-color);;\n}\n\n.question-mark {\n  font-size: 3.5vw;\n  color: #333;\n  font-family: Arial, sans-serif; \n  font-weight: bold; \n  line-height: 1;\n  vertical-align: middle; \n  margin-left: 10px;\n}\n\n.data-container {\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.fade-out {\n  opacity: 0;\n}\n\n.fade-in {\n  opacity: 1;\n}\n\n.chart-container {\n  width: 40vw;  \n  height: 20vw;  \n  margin: 0 auto;  \n  padding-top: 2vw;\n  padding-bottom: 10vw;\n  justify-items: center;\n}\n\n.chart-container h1 {\n  font-size: 2.4vw;\n  font-family: 'Arial', sans-serif;\n  font-weight: bold;\n  color: #333;\n  padding: 20px 0;\n  text-align: center;\n}\n\n.chart-container p {\n  text-align: center;\n  color:#595959;\n  font-size: 0.7vw;\n}\n\n.chart-container.doughnut {\n  height: 25vw;\n  padding-bottom: 8vw;\n}\n\n#doughnut {\n  position: relative;\n}\n\n.chart-container.country-chart {\n  width: 50vw;\n  height: 30vw;\n  padding-bottom: 5vw;\n}\n\n#countryChart {\n  width: 100%;\n  height: 100%; \n}\n\n.stat {\n  padding-top: 5vw;\n  font-size: 3vw;\n  text-align: center;\n  font-family: 'Arial', sans-serif;\n  font-weight: bold;\n  color: #333;\n}\n\n.stat-text, .stat-percent, .stat-timeframe {\n  display: inline;\n}\n\n.stat-percent.positive{\n  color: green;\n}\n\n.stat-percent.negative{\n  color: firebrick;\n}\n\n.wip {\n  padding-top: 5vw;\n}\n\n.wip h1 {\n  padding-top: 2vw;\n}\n\n.wip p {\n  padding-top: 2vw;\n  text-align: center;\n\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.section.b {\n  background-color: #eaeaea;\n  width: 100vw;\n}\n\n.chart-container.table {\n  height: 13vw;\n}\n\n#office-table {\n  border-collapse: collapse;\n  margin: 20px 0;\n  width: 50vw;\n}\n\n#office-table th, #office-table td {\n  padding: 12px 15px;\n  border: 2px solid #ddd;\n  text-align: center;\n  font-family: 'Arial', sans-serif;\n}\n\n#office-table th {\n  background-color: #eaeaea;\n  font-weight: bold;\n  font-size: 2.4vw;\n}\n\n#office-table td {\n  font-size: 2.4vw;\n}\n\n.row-0 {\n  color: green;\n}\n\n.row-2 {\n  color: firebrick;\n}\n\n.methodology-toggle {\n  cursor: pointer;\n}\n\n.methodology-toggle:hover {\n  text-decoration: underline;\n}\n\n.methodology-toggle h1 {\n  padding-top: 0vw;\n  padding: 2vw;\n}\n\n.methodology-toggle .arrow-down {\n  color: #333;\n}\n\n.methodology-panel {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n  width: 45vw;\n  margin: 0 auto;\n  display: block;\n  font-size: 15px;\n  justify-self: center;\n  text-align: center;\n  font-style: italic;\n}\n\n.methodology-panel.open {\n  display: block;\n  width: 45vw;\n  max-height: 500px;\n  transition: max-height 0.3s ease-in;\n  padding-bottom: 2vw;\n}\n\n.methodology-panel.closed {\n  display: none;\n  max-height: 0;\n}\n\n.methodology-panel ul {\n  list-style-position: inside; \n  padding: 0; \n  margin: 0 auto; \n  display: inline-block;\n  text-align: left;\n}\n\n.copyright {\n  font-size: 15px;\n  text-align: center;\n  padding: 15px;\n  color: #b2b2b2;\n}\n\n\n@media (max-width: 767px) {\n  h1 {\n      font-size: 8vw;\n      padding-top: 40vh;\n  }\n\n  .question-mark {\n      position: absolute;\n      font-size: 10vw;\n      padding-top: 3vw;\n  }\n\n  .custom-dropdown {\n    width: 55vw;\n    padding-top: 3vw;\n  }\n\n  .custom-dropdown-selected-text {\n    font-size: 8vw;\n    top: 0vw;\n    left: 4vw;\n  }\n\n  .custom-dropdown-options {\n    font-size: 5vw;\n  }\n\n  .arrow-down {\n    font-size: 8vw;\n  }\n\n  .chart-container {\n    padding-top: 5vw;\n    width: 80vw;  \n    margin: 0 auto;  \n    padding-bottom: 20vw;\n    min-height: 30vh;\n  }\n\n  .chart-container#postings {\n    padding-bottom: 29vw;\n  }\n\n  .chart-container h1 {\n    font-size: 5vw;\n  }\n\n\n  .stat {\n    padding-top: 10vw;\n    font-size: 8vw;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .stat-text, .stat-percent, .stat-timeframe {\n    display: block;\n    text-align: center;\n  }\n\n  .chart-container.doughnut{\n    position: relative;\n    height: 80vw;\n    width: 100%;\n    padding-bottom: 25vw;\n  }\n  \n  #doughnut {\n    top: 0vw;\n    left: 0vw;\n    width: 100%;\n    height: 30vw;\n    left: 10vw;\n  }\n\n  .chart-container.country-chart {\n    position: relative;\n    padding-bottom: 5vw;\n    right: 3vw;\n    width: 100vw;\n    height: 30vh;\n  }\n\n  .chart-container.table {\n    padding-bottom: 0vw;\n    width: 100vw;\n    justify-content: center;\n  }\n\n  #office-table {\n    position: relative;\n    width: 90vw;\n    left: 5vw;\n  }\n  \n  #office-table th {\n    font-size: 4vw;\n  }\n  \n  #office-table td {\n    font-size: 4vw;\n  }\n\n  .methodology-panel.open {\n    width: 95vw;\n    font-size: 12px;\n  }\n  \n  .copyright {\n    font-size: 15px;\n    text-align: center;\n    padding: 15px;\n    color: #b2b2b2;\n  }\n\n  .chart-container p {\n    font-size: 3vw;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
